import { render, staticRenderFns } from "./_Header-back.vue?vue&type=template&id=66a71af8&scoped=true&"
import script from "./_Header-back.vue?vue&type=script&lang=js&"
export * from "./_Header-back.vue?vue&type=script&lang=js&"
import style0 from "./_Header-back.vue?vue&type=style&index=0&id=66a71af8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a71af8",
  null
  
)

export default component.exports